module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/guestRequirement.svg?12f4feb4";